import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import Select from "react-select";
import {primarySelectTheme, primarySelectStyles, URLAPI} from "../../../config/index";
import CheckBox from "../../../components/check-box";
import {Link, useHistory, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {
    clear_employee,
    updateEmployee,
    UPDATE_EMPLOYEE,
    getAllEmployees
} from "../../../redux/employees";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingSpinner from "../../../components/loading-spinner";
import { get_all_cost_centers } from "../../../redux/cost_center";
import { get_all_companies } from "../../../redux/company";
import { getAllJobs } from "../../../redux/jobs";

const UpdateEmployee = () => {
    const dispatch = useDispatch();
    const {id} = useParams();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    /* A state variable that is used to store the form data. */
    const [form, setForm] = useState({
        rut: "",
        nombres: "",
        apellidos: "",
        id_cargo: 0,
        cargo: "",
        id_empresa: 0,
        id_centro_costo: 0,
        empresa: "",
        centro_costo: "",
        imagen: "",
        correo: "",
        telefono: "",
        fecha_ingreso: "",
        activo: true
    });

    const [isLoading, setIsLoading] = useState(false);
    const [job_select, setJobSelect] = useState(null);
    const [company_select, setCompanySelect] = useState(null);
    const [cost_center_select, setCostCenterSelect] = useState(null);

    let history = useHistory();

    useEffect(() => {
        dispatch(get_all_cost_centers(token));
        dispatch(get_all_companies(token))
        dispatch(getAllJobs(token))
    }, [dispatch, token]);

    const _companies = useSelector(
        (state) => state.company_module._get_all_companies
    );

    const _cost_center = useSelector(
        (state) => state.cost_center_module._get_all_cost_centers
    );

    const _update_employee = useSelector(
        (state) => state.employees_module._update_employee
    );

    const _get_all_employees = useSelector(
        (state) => state.employees_module._get_all_employees
    );

    const _jobs = useSelector((state) => state.jobs_module._get_all_jobs);

    const [companies, setCompanies] = useState([]);
    const [cost_centers, setCostCenters] = useState([]);

    useEffect(() => {
        if (_get_all_employees.data && _get_all_employees.data.datos) {
            // eslint-disable-next-line
            _get_all_employees.data.datos.map((item) => {
                if (item.id === parseInt(id)) {
                    setForm(item);
                    setJobSelect(item.id_cargo ? { value: item.id_cargo, label: item.cargo } : null);
                    setCompanySelect(item.id_empresa ? { value: item.id_empresa, label: item.empresa } : null);
                    setCostCenterSelect(item.id_centro_costo ? { value: item.id_centro_costo, label: item.centro_costo } : null);
                }
            });
        }
    }, [_get_all_employees, id]);

    useEffect(() => {
        if (_companies.data.datos) {
            setCompanies(_companies.data.datos);
        }
    }, [_companies]);

    useEffect(() => {
        if (_cost_center.data.datos) {
            setCostCenters(_cost_center.data.datos);
        }
    }, [_cost_center]);

    /* A state variable that is used to store the form data. */
    useEffect(() => {
        if (_update_employee.status === 200) {
            toast.success("El empleado ha sido creado correctamente")
            dispatch(clear_employee(UPDATE_EMPLOYEE));
            history.push("/empleados");
            dispatch(getAllEmployees(token));
            setIsLoading(false);
        } else {
            if (_update_employee.status !== 0) {
                toast.error(_update_employee.message);
                setIsLoading(false);
            }
        }
    }, [_update_employee, token, dispatch, history]);

    useEffect(() => {
    }, []);

    const [jobs, setJobs] = useState([]);

    useEffect(() => {
        if (_jobs && _jobs.data && _jobs.data.datos ) {
            let cargos = _jobs.data.datos.filter(x => x.activo === true)
            setJobs(cargos);
        }
    }, [_jobs]);

    const handleChange = (e) => {
        if (e.target.name === 'activo') {
            setForm({
                ...form,
                [e.target.name]: e.target.checked,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }

    };

    const [imagePreview, setImagePreview] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        let url = URL.createObjectURL(file);
        setImagePreview(url);
        setForm({
            ...form,
            imagen: e.target.files[0],
        });
    };

    const handleChangeJob = (e) => {
        setForm({ ...form, id_cargo: e ? parseInt(e.value) : 0 });
        setJobSelect(e);
    };

    const handleChangeCompany = (e) => {
        setForm({ ...form, id_empresa: e ? parseInt(e.value) : 0 });
        setCompanySelect(e);
    };

    const handleChangeCostCenter = (e) => {
        setForm({ ...form, id_centro_costo: e ? parseInt(e.value) : 0 });
        setCostCenterSelect(e);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        //validate fields
        if (form.rut === "") {
            toast.error("Debe ingresar el rut");
            setIsLoading(false);
            return;
        }
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre");
            setIsLoading(false);
            return;
        }
        if (form.apellidos === "") {
            toast.error("Debe ingresar el apellido");
            setIsLoading(false);
            return;
        }
        if (form.id_cargo === 0) {
            toast.error("Debe seleccionar el cargo");
            setIsLoading(false);
            return;
        }
        if (form.id_empresa === 0) {
            toast.error("Debe seleccionar la empresa");
            setIsLoading(false);
            return;
        }

        if (form.id_centro_costo === 0) {
            toast.error("Debe seleccionar el centro de costo");
            setIsLoading(false);
            return;
        }
        if (form.imagen === "") {
            toast.error("La imagen es requerida");
            setIsLoading(false);
            return;
        }
        dispatch(updateEmployee(token, id, form));
    };

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-overlay"/>
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Empleados"
                            items={[
                                {label: "Empleados", link: "/empleados"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar Empleado</h4>
                                </div>
                                <div className="card-body">
                                    <div className=" row">
                                        <div className="col-md-4">
                                            <Input
                                                label="Rut"
                                                name="rut"
                                                onChange={handleChange}
                                                value={form.rut}
                                                readonly="readonly"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                label="Nombre"
                                                name="nombres"
                                                onChange={handleChange}
                                                value={form.nombres}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                label="Apellidos"
                                                name="apellidos"
                                                onChange={handleChange}
                                                value={form.apellidos}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                label="Correo"
                                                name="correo"
                                                onChange={handleChange}
                                                value={form.correo}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                label="Telefono"
                                                name="telefono"
                                                onChange={handleChange}
                                                value={form.telefono}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                type="date"
                                                label="Fecha Ingreso"
                                                name="fecha_ingreso"
                                                onChange={handleChange}
                                                value={form.fecha_ingreso}
                                            />
                                        </div>
                                    </div>
                                    <div className=" row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Cargo</label>
                                                <Select
                                                    theme={primarySelectTheme}
                                                    styles={primarySelectStyles}
                                                    options={jobs.map((job) => ({ value: job.id, label: job.nombre }))}
                                                    isMulti={false}
                                                    onChange={handleChangeJob}
                                                    value={job_select}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Empresa</label>
                                                <Select
                                                    theme={primarySelectTheme}
                                                    styles={primarySelectStyles}
                                                    options={companies.map((company) => ({ value: company.id, label: company.nombre }))}
                                                    isMulti={false}
                                                    onChange={handleChangeCompany}
                                                    value={company_select}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Centro de costo</label>
                                                <Select
                                                    theme={primarySelectTheme}
                                                    styles={primarySelectStyles}
                                                    options={cost_centers.map((item) => ({ value: item.id, label: item.nombre }))}
                                                    isMulti={false}
                                                    onChange={handleChangeCostCenter}
                                                    value={cost_center_select}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                label="Imagen"
                                                name="imagen"
                                                type="file"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                        <div className="col-md-6 text-center">
                                            <img
                                                src={
                                                    imagePreview == null
                                                        ? form.foto
                                                        : imagePreview
                                                }
                                                alt="imagen"
                                                width={60}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <CheckBox label="Activo" name="activo" id="activo" onChange={handleChange}
                                                      state={form.activo}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    <Link to="/empleados" className="btn btn-outline-dark m-1">
                                        Cancelar
                                    </Link>
                                    <Button
                                        text="Guardar"
                                        theme="success"
                                        type="submit"
                                        classes="m-1"
                                        onClick={handleSubmit}
                                        disabled={isLoading}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateEmployee;
